import { useState } from 'react';
import { get } from 'lodash';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import { useFeatureFlag } from 'common/hooks';
import { usePopulate, useFind } from 'api/APIHooks';
import { PENDING_AND_APPROVED_STATUSES } from 'pages/invoices/constants';

export default function useAuthorizationFormData(authorization) {
  const [isAmountExceeded, setIsAmountExceeded] = useState(false);
  const defaultQueryConfig = { queryConfig: { placeholderData: undefined } };

  usePopulate('insurance', 'insurance', authorization, defaultQueryConfig);
  usePopulate('case', 'case', authorization, defaultQueryConfig);
  usePopulate('case.person', 'person', authorization, defaultQueryConfig);
  usePopulate('clinical_modifications', 'clinical_modifications', authorization, defaultQueryConfig);

  const feeScheduleProgram = get(authorization, 'fee_schedule_program', {});
  const person = get(authorization, 'case.person', {});
  const updateEditAuthorizationsFeatureEnabled = useFeatureFlag('pays-5650-update-edit-authorizations');

  const {
    data: invoicedSpendData,
    isSuccess: isInvoicedSpendLoaded,
  } = useFind(
    'invoiced_spend',
    {
      fee_schedule_program: feeScheduleProgram.id,
      person: person.id,
      service_authorization: authorization.id,
      state: PENDING_AND_APPROVED_STATUSES.join(','),
    },
    {
      queryConfig: {
        enabled: Boolean(
          feeScheduleProgram.id && person.id && authorization.id &&
          updateEditAuthorizationsFeatureEnabled,
        ),
        refetchOnMount: 'always',
        placeholderData: undefined,
      },
    },
  );

  const totalInvoicedSpend = get(invoicedSpendData, 'data.meta.total_spend', 0);
  const invoicedSpendRecords = get(invoicedSpendData, 'data.data', []);

  const initialClinicalModificationCodeValue = authorization.clinical_modifications?.length > 0 ?
    {
      value: authorization.clinical_modifications[0].code,
      label: authorization.clinical_modifications[0].code,
      id: authorization.clinical_modifications[0].id,
    } :
    null;

  const isCostBased = fspUtils.isCostPaymentType(feeScheduleProgram.payment_type);
  const isUnitBased = !isCostBased;

  return {
    feeScheduleProgram,
    person,
    isCostBased,
    isUnitBased,
    isAmountExceeded,
    setIsAmountExceeded,
    totalInvoicedSpend,
    invoicedSpendRecords,
    isInvoicedSpendLoaded,
    initialClinicalModificationCodeValue,
  };
}
